<template>
  <div class="lunbo">
    <carousel
      :autoplay="true"
      :loop="true"
      :responsive="responsiveOptions"
      :autoplayTimeout="7000"
      :smartSpeed="800"
      autoHeight
      :dots="false"
      :nav="false"  
    >
      <div class="item" v-for="(image, index) in images" :key="index">
        <img :src="image.src" :alt="image.alt" />
      </div>
    </carousel>
  </div>
</template>

<script>
import Carousel from 'vue-owl-carousel'

export default {
  name: 'CustomerLogos',
  components: { Carousel },
  data() {
    return {
      images: [
        { src: require("../assets/x1.png") }, 
        { src: require("../assets/x2.png") }, 
        { src: require("../assets/x3.png") },
        { src: require("../assets/x4.png") },
        { src: require("../assets/x5.png") },
      ],
      responsiveOptions: {
        0: { items: 3 },
        600: { items: 3 },
        1024: { items: 5 },
        1366: { items: 5 }
      }
    }
  }
}
</script>

<style scoped>
.lunbo {
  width: 100%;
  /* height: 30vh; */
}

img {
  height: 100%;
  width: auto;
  object-fit: cover;
}

.owl-item {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.item {
  width: 100%;
  height: 100%;
}

/* 从 CSS 样式中移除指示点和按钮 */
.owl-dots, .owl-nav {
  display: none;
}
</style>
